"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var useEditableField_1 = require("@features/ItemCommon/hooks/useEditableField");
var TreeOrSelect_1 = __importDefault(require("@features/ItemCommon/components/common/SelectTree/TreeOrSelect"));
var treeDataUtil_1 = require("@features/ItemCommon/components/common/SelectTree/treeDataUtil");
var CopyIcon_1 = __importDefault(require("@components/CopyIcon"));
var QuickAddToList_1 = __importDefault(require("@components/QuickAddToList"));
function SelectTree(_a) {
    var label = _a.label, data = _a.data, isNotEditable = _a.isNotEditable, value = _a.value, setValue = _a.setValue, cyName = _a.cyName, domain = _a.domain, automationListsPermission = _a.automationListsPermission;
    var _b = (0, useEditableField_1.useEditableField)(value, isNotEditable), mode = _b.mode, handleClick = _b.handleClick, resetToOriginalValue = _b.resetToOriginalValue, setMode = _b.setMode;
    var treeMode = data && (0, treeDataUtil_1.getOpenMode)(data);
    var isEditable = !isNotEditable && data && data.length > 0;
    var classes = (0, clsx_1.default)({
        'item-detail-field': !isEditable,
        'item-detail-field-edit': isEditable,
    });
    return (react_1.default.createElement("div", { className: classes, "data-cy": "job-category" },
        react_1.default.createElement("div", { className: "item-detail-field__label" }, label),
        mode === 'VIEW' && (react_1.default.createElement("div", { className: (0, clsx_1.default)('item-detail-field-value-container', { 'item-detail-field-clickable': isEditable }), onClick: function () {
                if (isEditable) {
                    handleClick();
                }
            } },
            react_1.default.createElement("div", { "data-cy": "".concat(cyName, "-value"), className: "item-detail-field__value--disabled" }, value.name),
            !isNotEditable &&
                (treeMode === treeDataUtil_1.TreeOpenMode.TWO_LEVEL_DROPDOWN ||
                    treeMode === treeDataUtil_1.TreeOpenMode.ONE_LEVEL_DROPDOWN ||
                    treeMode === treeDataUtil_1.TreeOpenMode.TREE) && react_1.default.createElement("i", { className: "job-category-select-icon implioicons-arrow-down" }),
            isNotEditable && (react_1.default.createElement("div", { className: "eva-job-key-value-item__icon-container" },
                react_1.default.createElement(CopyIcon_1.default, { value: String(value.name) }),
                react_1.default.createElement(QuickAddToList_1.default, { domain: domain, word: String(value.name), label: label, automationListsPermission: automationListsPermission }))))),
        mode === 'EDIT' && data && treeMode && (react_1.default.createElement(TreeOrSelect_1.default, { categories: data, current: value, resetToOriginalValue: resetToOriginalValue, setMode: setMode, setCategory: function (cat) {
                setValue(cat);
                setMode('VIEW');
            }, treeMode: treeMode }))));
}
exports.default = SelectTree;
